import Vue from "vue";
import Router from "vue-router";
import Login from "@/pages/Login";
import Init from "@/pages/Init";
import EventWrapper from "@/components/EventWrapper";

import EventInfo from "@/pages/event/EventInfo";
import Speakers from "@/pages/event/Speakers";
import EventAlbum from "@/pages/event/EventAlbum";
import Tags from "@/pages/event/Tags";
import AreaMaps from "@/pages/event/AreaMaps";
import ProgramRate from "@/pages/event/ProgramRate";
import QuestionLibrary from "@/pages/event/QuestionLibrary";
import Packets from "@/pages/event/Packets";
import Venues from "@/pages/event/Venues";
import Program from "@/pages/event/Program";
import Sponsors from "@/pages/event/Sponsors";
import Files from "@/pages/event/Files";
import Participants from "@/pages/event/Participants";
import Payments from "@/pages/event/Payments";
import RegistrationForm from "@/pages/event/RegistrationForm";
import RegisterFormScreen from "@/pages/event/RegisterFormScreen";
import EventDashboard from "@/pages/event/EventDashboard";
// import SubEventRegistrations from '@/pages/event/SubEventRegistrations';
import LiveSessions from "@/pages/event/LiveSessions";
import Polls from "@/pages/event/Polls";
import Social from "@/pages/event/Social";
import Stands from "@/pages/event/Stands";
import MyAccount from "@/pages/MyAccount";
import Register from "@/pages/Register";
import Maintenance from "@/pages/502.vue";
import ForgotPassword from "@/pages/ForgotPassword";
import NewAccount from "@/pages/NewAccount";
import Search from "@/pages/event/Search";
import MobileControl from "@/pages/event/MobileControl";
import Promotions from "@/pages/event/Promotions";
import NotFound from "@/pages/event/NotFound";
import PrintScheme from "@/pages/event/PrintScheme";
import PromotionHistory from "@/pages/event/PromotionHistory";
import Networking from "@/pages/event/Networking";
import Reports from "@/pages/event/Reports";
import Users from "@/components/Users";
import Surveys from "@/pages/event/Surveys";
import Certificates from "@/pages/event/Certificates";
import AddUpdateCertificate from "@/pages/event/AddUpdateCertificate";
import subEvents from "@/pages/event/subEvents";
import additionalProducts from "@/pages/event/AdditionalProducts";
import Automatedmessages from "@/pages/event/Automatedmessages";
import SeatingPlanner from "@/pages/event/SeatingPlanner";
import Tweetwall from "@/pages/event/Tweetwall";
import AbstractManagement from "@/pages/event/AbstractManagement";
import Accomodation from "@/pages/event/Accomodation";
import MyOwnEvents from "@/pages/MyOwnEvents";
import Organisation from "@/pages/Organisation";
import OrganisationOverview from "@/pages/OrganisationOverview";
import OrganisationEvents from "@/pages/OrganisationEvents";
import OrganisationAttendees from "@/pages/OrganisationAttendees";
import OrganisationTeam from "@/pages/OrganisationTeam";
import OrganisationProfile from "@/pages/OrganisationProfile";
import OrganisationIntegrations from "@/pages/OrganisationIntegrations";
import OrganisationBilling from "@/pages/OrganisationBilling";
import OrganisationSettings from "@/pages/OrganisationSettings";
import store from "../store/index";
Vue.use(Router);

async function generalControl(to, from, next, roleSet) {
  var role = store.getters.getEventRole;
  var token = localStorage.getItem("token");
  if (role == null && (token != null || token != undefined)) {
    await store.dispatch("getEvent");
    role = store.getters.getEventRole;
  }
  next();
}

export default new Router({
  linkActiveClass: "active",
  linkExactActiveClass: "active",
  mode: "history",
  routes: [
    {
      path: "/",
      component: Init,
      children: [
        {
          path: "",
          component: MyOwnEvents,
          name: "myevents"
        },
        {
          path: "/create-event",
          component: AbstractManagement,
          name: "create-event"
        },
        {
          path: "/organisation/:organisation_id",
          component: Organisation,
          children: [
            {
              path: "",
              component: OrganisationOverview,
              name: "overview"
            },
            {
              path: "events",
              component: OrganisationEvents,
              name: "events"
            },
            // {
            //     path: 'attendees',
            //     component: OrganisationAttendees,
            //     name: 'attendees',
            // },
            {
              path: "team",
              component: OrganisationTeam,
              name: "team"
            },
            {
              path: "profile",
              component: OrganisationProfile,
              name: "profile"
            },
            {
              path: "integrations",
              component: OrganisationIntegrations,
              name: "integrations"
            },
            {
              path: "billing",
              component: OrganisationBilling,
              name: "billing"
            },
            {
              path: "billing/:id",
              component: OrganisationBilling,
              name: "billing-iyzico"
            }
            // {
            //     path: 'settings',
            //     component: OrganisationSettings,
            //     name: 'settings',
            // },
          ]
        }
      ]
    },

    // {
    //     path: '/new-account',
    //     name: 'new-account',
    //     component: NewAccount,
    // },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/maintenance",
      name: "maintenance",
      component: Maintenance
    },
    {
      path: "/forgot-password",
      name: "forgot-password",
      component: ForgotPassword
    },
    {
      path: "/register/:code?",
      name: "register",
      component: Register
    },
    {
      path: "/event/:event_id",
      component: EventWrapper,
      children: [
        {
          name: "event",
          component: EventInfo,
          path: "event-info",
          beforeEnter: (to, from, next) => generalControl(to, from, next, [1, 2, 3, 4, 5, 6, 7, 8])
        },
        {
          name: "speakers",
          component: Speakers,
          path: "speakers"
        },
        {
          name: "dashboard",
          component: EventDashboard,
          path: "event-dashboard"
        },
        {
          name: "event-album",
          component: EventAlbum,
          path: "event-album"
        },

        {
          name: "tags",
          component: Tags,
          path: "tags"
        },
        {
          name: "area-maps",
          component: AreaMaps,
          path: "area-maps"
        },
        {
          name: "programrate",
          component: ProgramRate,
          path: "programrate"
        },
        {
          name: "questionlibrary",
          component: QuestionLibrary,
          path: "questionlibrary"
        },
        {
          name: "packets",
          component: Packets,
          path: "packets"
        },

        {
          name: "venues",
          component: Venues,
          path: "venues"
        },
        {
          name: "program",
          component: Program,
          path: "program"
        },
        {
          name: "sponsors",
          component: Sponsors,
          path: "sponsors"
        },
        {
          name: "files",
          component: Files,
          path: "files"
        },
        {
          name: "participants",
          component: Participants,
          path: "participants"
        },
        {
          name: "payments",
          component: Payments,
          path: "payments"
        },
        {
          name: "registration-form",
          component: RegistrationForm,
          path: "registration-form"
        },
        {
          name: "new-registration-form",
          component: RegisterFormScreen,
          path: "new-registration-form"
        },
        // {
        //     name: 'sub-event-registration',
        //     component: SubEventRegistrations,
        //     path: 'sub-event-registration',
        // },
        {
          name: "sub-events",
          component: subEvents,
          path: "sub-events"
        },
        {
          name: "additional-products",
          component: additionalProducts,
          path: "additional-products"
        },
        {
          name: "automated-messages",
          component: Automatedmessages,
          path: "automated-messages"
        },
        {
          name: "live-sessions",
          component: LiveSessions,
          path: "live-sessions"
        },
        {
          name: "polls",
          component: Polls,
          path: "polls"
        },
        {
          name: "social",
          component: Social,
          path: "social"
        },
        {
          name: "stands",
          component: Stands,
          path: "stands"
        },
        {
          name: "search",
          component: Search,
          path: "search"
        },
        {
          name: "mobile-control",
          component: MobileControl,
          path: "mobile-control"
        },
        {
          name: "promotions",
          component: Promotions,
          path: "promotions"
        },
        {
          name: "print-scheme",
          component: PrintScheme,
          path: "print-scheme"
        },
        {
          name: "promotion-history",
          component: PromotionHistory,
          path: "promotion-history"
        },
        {
          name: "networking",
          component: Networking,
          path: "networking"
        },
        {
          name: "reports",
          component: Reports,
          path: "reports"
        },
        {
          name: "seating-planner",
          component: SeatingPlanner,
          path: "seating-planner"
        },
        {
          name: "tweet-wall",
          component: Tweetwall,
          path: "tweet-wall"
        },
        {
          name: "abstract-management",
          component: AbstractManagement,
          path: "abstract-management"
        },
        {
          name: "accomodation-transfer",
          component: Accomodation,
          path: "accomodation-transfer"
        },
        {
          name: "certificates",
          component: Certificates,
          path: "certificates"
        },
        {
          name: "add-certificate",
          component: AddUpdateCertificate,
          path: "add-certificate/:id?"
        },

        {
          name: "users",
          component: Users,
          path: "users"
        },
        {
          name: "surveys",
          component: Surveys,
          path: "surveys"
        }
      ]
    },
    {
      path: "*",
      component: NotFound
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js